/** Medellín metro / valley cities for AutoMapa inventory scope. */

export const MEDELLIN_VALLEY_CITY_TOKENS = Object.freeze([
  "medellin",
  "envigado",
  "sabaneta",
  "itagui",
  "bello",
  "la estrella",
  "rionegro",
  "copacabana",
  "caldas",
  "barbosa",
]);

export function normalizeCityToken(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim();
}

export function isMedellinValleyCity(city) {
  const token = normalizeCityToken(city);
  if (!token) return false;
  return MEDELLIN_VALLEY_CITY_TOKENS.some(
    (needle) => token === needle || token.includes(needle)
  );
}
